module.exports = __webpack_public_path__ + "static/media/Sec-1_2677HomePlayer_EN.90c46f48.webp";